export default __webpack_public_path__ + "static/media/clasificacion.2c14db8d.svg";